import Crud from '../components/Term/Crud'
import Entity from '../components/Term/Add'
import Edit from '../components/Term/Edit'

let routes = {
    path: '/terms',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/terms/add',
            name: 'Novo Termo',
            component: Entity
        },
        {
            path: '/terms/edit/:id?',
            name: 'Editar Termo',
            component: Edit
        },
        {
            path: '/terms',
            name: 'Termos',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/term.js